module.exports = __webpack_public_path__ + "static/assets/d8aa8f7a1fbfb47233c1d90287ee5982.svg";